import { Button, ButtonProps, chakra, useDisclosure } from '@chakra-ui/react';
import * as React from 'react';

import { sponsor_content_clicked } from '@/analytics';
import { useSignUpPrompt } from '@/hooks/useSignUpPrompt';
import { IRequestDemoView } from '@/types/analytics';

import { RequestDemoModal } from './components/RequestDemoModal';

export const REGISTER_INTEREST_DEFAULT_TEXT = 'Request a Demo';

type IRequestDemoButtonProps = ButtonProps & {
  options: {
    organizationId: string;
    registerInterestTitle: string | null;

    origin: {
      conferenceBoothId?: string;
      sponsoredEventId?: string;
      sponsoredConferenceSessionId?: string;
      hostedEventId?: string;
      sponsorPage?: boolean;
      featuredSponsorCard?: boolean;
    };

    analytics: {
      view: IRequestDemoView;
      tier: string;
    };
  };
};

export const RequestDemoButton: React.FC<IRequestDemoButtonProps> = ({
  options,
  ...props
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { promptModal, withPrompt } = useSignUpPrompt();

  const registerInterestTitle =
    options.registerInterestTitle || REGISTER_INTEREST_DEFAULT_TEXT;

  return (
    <>
      {promptModal}
      <RequestDemoModal
        isOpen={isOpen}
        onClose={onClose}
        organizationId={options.organizationId}
        registerInterestTitle={registerInterestTitle}
        origin={options.origin}
        analytics={options.analytics}
      />
      <Button
        whiteSpace="normal"
        {...props}
        onClick={withPrompt(() => {
          sponsor_content_clicked({
            entity_type: 'sponsor',
            entity_id: options.organizationId,
            sponsor_id: options.organizationId,
            sponsor_content_type: 'request_demo_cta',
            sponsor_content_id: options.organizationId,
            sponsor_cta_text: registerInterestTitle,
            sponsor_tier: options.analytics.tier,
            sponsor_interaction_source: options.origin.sponsorPage
              ? 'sponsor_detail'
              : options.origin.sponsoredEventId ||
                  options.origin.hostedEventId ||
                  options.origin.conferenceBoothId ||
                  options.origin.sponsoredConferenceSessionId
                ? 'event'
                : options.origin.featuredSponsorCard
                  ? 'featured_sponsor'
                  : options.analytics.view,
            event_backed_sponsor_interaction: Boolean(
              options.origin.sponsoredEventId ||
                options.origin.hostedEventId ||
                options.origin.conferenceBoothId ||
                options.origin.sponsoredConferenceSessionId
            ),
            event_sponsor_id: options.organizationId,
            event_id:
              options.origin.sponsoredEventId ||
              options.origin.hostedEventId ||
              undefined,
            event_session_id:
              options.origin.conferenceBoothId ||
              options.origin.sponsoredConferenceSessionId ||
              undefined,
            is_sponsor_interaction: true,
          });
          onOpen();
        })}
        id="requestDemoButton"
      >
        <chakra.span noOfLines={1} wordBreak="break-all">
          {registerInterestTitle}
        </chakra.span>
      </Button>
    </>
  );
};
